/*******************************************
 * ROBOT list actions
 ******************************************/
import { MapRegion, RobotMaps, RobotMapVersion } from '../../../models/qa-models/robot-maps';

export class LoadAllRobots {
  public static readonly type = '[QA] Load All Robots';
  constructor() {}
}

export class LoadOwnerRobots {
  public static readonly type = '[QA] Load Owner Robots';
  constructor() {}
}

export class LoadOwnerRobotsSuccess {
  public static readonly type = '[QA] Load Owner Robots SUCCESS';
  constructor(public payload: any) {}
}

export class LoadRobotsSuccess {
  public static readonly type = '[QA] Load Robots SUCCESS';
  constructor(public payload: any) {}
}

export class LoadRobotsFail {
  public static readonly type = '[QA] Load Robots FAIL';
  constructor() {}
}

export class ReloadAllRobots {
  public static readonly type = '[QA] Reload All Robots';
  constructor() {}
}

export class ReloadOwnerRobots {
  public static readonly type = '[QA] Reload Owner Robots';
  constructor() {}
}

export class ReloadRobotsSuccess {
  public static readonly type = '[QA] Reload Robots SUCCESS';
  constructor(public payload: any) {}
}

export class ReloadRobotsFail {
  public static readonly type = '[QA] Reload Robots FAIL';
  constructor() {}
}

export class PostRobots {
  public static readonly type = '[QA] Post Robots';
  constructor(public payload: any, public edit?: boolean) {}
}

export class DeleteRobots {
  public static readonly type = '[QA] Delete Robots';
  constructor(public payload: any) {}
}

export class DeleteRobotsSuccess {
  public static readonly type = '[QA] Delete Robots SUCCESS';
  constructor(public payload: any) {}
}

export class SaveRobotComplete {
  public static readonly type = '[QA] Robot Save Complete';
  constructor(public data: any, public robots: any) {}
}

export class SaveRobotFail {
  public static readonly type = '[QA] Robot Save Fail';
  constructor(public payload: any) {}
}

/*******************************************
 *          QA Tool Notification Test
 ******************************************/
export class QAPostNotificationSuccess {
  public static readonly type = '[QA] Post Notification SUCESS';
  constructor() {}
}

export class QAPostNotificationFail {
  public static readonly type = '[QA] Post Notification Fail';
  constructor(public payload: any) {}
}

/*******************************************
 *          Favorite Recommendation
 ******************************************/
export class LoadRobotMapsSuccess {
  public static readonly type = '[QA] Load Robot Maps';
  constructor(public robotMaps: RobotMaps) {}
}

export class LoadRobotMapVersionsSuccess {
  public static readonly type = '[QA] Load Robot Map Versions';
  constructor(public rmv: RobotMapVersion) {}
}

export class LoadRobotMapRegionsSuccess {
  public static readonly type = '[QA] Load Robot Map Regions';
  constructor(public regions: MapRegion[]) {}
}

export class RtpSendSuccess {
  public static readonly type = '[QA] RTP Send Success';
  constructor() {}
}

export class RtpSendFailed {
  public static readonly type = '[QA] RTP Send Failed';
  constructor() {}
}
